import DadHotel from "./assets/dad-hotel.jpg";
import EspinasPalaceHotel from "./assets/espinas-palace-hotel.jpg";
import GhasrMonshiBoutiqueHotel from "./assets/ghasr-monshi-boutique-hotel.jpg";
import KarvanicaHotel from "./assets/karvanica-hotel.jpg";
import SarayeAmerihaHotel from "./assets/saraye-ameriha-hotel.jpg";

export const popularCities = [
  {
    image: EspinasPalaceHotel.src,
    city: "هتل اسپیناس پالاس",
    state: "هتل اسپیناس پالاس",
    alt: "هتل اسپیناس پالاس",
    href: `تهران/هتل-اسپیناس-پالاس-کلکسیون-لوکس-گروه-هتل-های-اسپیناس`
  },
  {
    image: DadHotel.src,
    city: "هتل داد",
    state: "هتل داد",
    alt: "هتل داد",
    href: `یزد/هتل-داد`
  },
  {
    image: GhasrMonshiBoutiqueHotel.src,
    city: "هتل قصر منشی",
    state: "هتل قصر منشی",
    alt: "هتل قصر منشی",
    href: `اصفهان/بوتیک-هتل-قصر-منشی`
  },

  {
    image: SarayeAmerihaHotel.src,
    city: "هتل عامری ها",
    state: "هتل عامری ها",
    alt: "هتل عامری ها",
    href: `کاشان/اقامتگاه-سنتی-سرای-عامری-ها`
  },
  {
    image: KarvanicaHotel.src,
    city: " هتل کاروانیکا",
    state: " هتل کاروانیکا",
    alt: " هتل کاروانیکا",
    href: `کرمان/بوتیک-هتل-وکیل-(کاروانیکا)`
  }
];
